import { Link } from "react-router-dom";
import manifestLogo from "@/assets/manifest-logo.webp";

interface MarketingNavProps {
  /**
   * When true, in-page anchor links (#features, #pricing, etc.) are rendered
   * as relative links so they navigate back to Landing. Set to false on
   * Landing itself, where they should scroll within the page.
   */
  linksToHome?: boolean;
}

/**
 * Shared sticky top nav for marketing/public pages: Landing, Blog, BlogPost,
 * and the public tools (e.g. ACV/RCV calculator).
 */
export default function MarketingNav({ linksToHome = true }: MarketingNavProps) {
  const anchor = (hash: string) => (linksToHome ? `/${hash}` : hash);

  return (
    <nav
      className="sticky top-0 z-50 border-b border-[#E5E5E0] bg-[#FAFAF7]/80"
      style={{ backdropFilter: "blur(16px) saturate(180%)" }}
    >
      <div className="mx-auto flex h-14 max-w-[1200px] items-center justify-between px-5">
        <Link to="/" className="flex items-center gap-2.5">
          <div className="h-[30px] w-[30px] rounded-lg overflow-hidden">
            <img src={manifestLogo} alt="Manifest" className="h-full w-full object-contain" />
          </div>
          <span className="font-editorial text-[1.5rem]">Manifest</span>
        </Link>
        <div className="hidden md:flex items-center gap-1">
          <a
            href={anchor("#how-it-works")}
            className="px-3 py-1.5 text-[13px] font-medium text-[#6B7280] hover:bg-[#F0EFEB] rounded-lg transition-colors"
          >
            How it works
          </a>
          <a
            href={anchor("#features")}
            className="px-3 py-1.5 text-[13px] font-medium text-[#6B7280] hover:bg-[#F0EFEB] rounded-lg transition-colors"
          >
            Features
          </a>
          <a
            href={anchor("#pricing")}
            className="px-3 py-1.5 text-[13px] font-medium text-[#6B7280] hover:bg-[#F0EFEB] rounded-lg transition-colors"
          >
            Pricing
          </a>
          <Link
            to="/tools/acv-rcv-calculator"
            className="px-3 py-1.5 text-[13px] font-medium text-[#6B7280] hover:bg-[#F0EFEB] rounded-lg transition-colors"
          >
            Calculator
          </Link>
          <Link
            to="/blog"
            className="px-3 py-1.5 text-[13px] font-medium text-[#6B7280] hover:bg-[#F0EFEB] rounded-lg transition-colors"
          >
            Blog
          </Link>
          <Link
            to="/login"
            className="px-3 py-1.5 text-[13px] font-medium text-[#6B7280] hover:bg-[#F0EFEB] rounded-lg transition-colors"
          >
            Sign in
          </Link>
        </div>
        <Link
          to="/login"
          className="rounded-lg bg-[#111] px-4 py-1.5 text-sm font-semibold text-white hover:bg-[#222] transition-colors"
        >
          Start free
        </Link>
      </div>
    </nav>
  );
}
